import React from "react";

import { ClassNameUtilities } from "@assets/utilities";
import Tooltip from "@components/Tooltip/tooltip";
import { t } from "i18next";
import { FiInfo } from "react-icons/fi";

export type labelCases = "upper" | "lower" | "capitalize" | "none";

type LabelExProps = {
  /** The content of the component. */
  children: string;
  /** Override or extend the style applied to the component. */
  className?: string;
  /** The id of the element the label is bound to. */
  forID?: string;
  /** Transform the label displayed case. */
  labelCase?: "upper" | "lower" | "capitalize" | "none";
  labelColor?: "neutral-800" | "neutral-900";
  /* If true, the input element shows an optional text. */
  optional?: boolean;
  /** Set the optional text to show. !NOTE: use with optional=true. */
  optionalText?: string;
  /**	If true, the input element is required. */
  required?: boolean;
  tooltipContent?: string;
};

const labelCases = {
  upper: "uppercase",
  lower: "lowercase",
  capitalize: "capitalize",
  none: "normal-case",
};

const labelColors = {
  "neutral-800": "text-neutral-800",
  "neutral-900": "text-neutral-900",
};

export const LabelEx: React.FC<LabelExProps> = ({
  children,
  className,
  forID,
  labelCase = "none",
  labelColor = "neutral-800",
  optional = false,
  optionalText = `${`(` + t("LABEL_OPTIONAL") + `)`}`,
  required = false,
  tooltipContent,
}) => (
  <div className="flex">
    <label
      className={ClassNameUtilities.classNames(
        "inline-block leading-5.5",
        labelColors[labelColor],
        className,
        labelCases[labelCase]
      )}
      htmlFor={forID}
    >
      {children}
      {required ? " *" : ""}
      {optional && optionalText ? ` ${optionalText}` : ""}
    </label>
    {tooltipContent ? (
      <Tooltip childClassName="inline-flex" content={tooltipContent}>
        <FiInfo className="cursor-help inline-block ml-1 text-primary" />
      </Tooltip>
    ) : (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <></>
    )}
  </div>
);

export default LabelEx;
